export enum MainPageTabs {
  DASHBOARD = "dashboard",
  DASHBOARD_PRO = "dashboard_pro",
  MANUALS = "manuals",
  COMMISSION = "commission",
}
